module.exports = __webpack_public_path__ + "img/how-it-works1.673662f0.svg";